import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AuthCallback } from "@/components/AuthCallback";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Sprouts from "@/pages/Sprouts";
import SproutDetail from "@/pages/SproutDetail";
import Guides from "@/pages/Guides";
import Assistant from "@/pages/Assistant";
import Harvests from "@/pages/Harvests";
import PlantingCalendar from "@/pages/PlantingCalendar";
import GardenPlanner from "@/pages/GardenPlanner";
import Pricing from "@/pages/Pricing";
import SignupSources from "@/pages/SignupSources";
import { captureAttribution } from "@/lib/attribution";

captureAttribution();

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </ThemeProvider>
  );
}

function AppRoutes() {
  const location = useLocation();
  // Google OAuth returns to {origin}/#session_id=... — handle it before any route/guard runs.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sprouts"
              element={
                <ProtectedRoute>
                  <Sprouts />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sprouts/:id"
              element={
                <ProtectedRoute>
                  <SproutDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/guides"
              element={
                <ProtectedRoute>
                  <Guides />
                </ProtectedRoute>
              }
            />
            <Route
              path="/assistant"
              element={
                <ProtectedRoute>
                  <Assistant />
                </ProtectedRoute>
              }
            />
            <Route
              path="/harvests"
              element={
                <ProtectedRoute>
                  <Harvests />
                </ProtectedRoute>
              }
            />
            <Route
              path="/calendar"
              element={
                <ProtectedRoute>
                  <PlantingCalendar />
                </ProtectedRoute>
              }
            />
            <Route
              path="/planner"
              element={
                <ProtectedRoute>
                  <GardenPlanner />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pricing"
              element={
                <ProtectedRoute>
                  <Pricing />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/sources"
              element={
                <ProtectedRoute>
                  <SignupSources />
                </ProtectedRoute>
              }
            />
    </Routes>
  );
}

export default App;
